import { render, staticRenderFns } from "./Ckgl.vue?vue&type=template&id=3a53d88a&scoped=true&"
import script from "./Ckgl.vue?vue&type=script&lang=js&"
export * from "./Ckgl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a53d88a",
  null
  
)

export default component.exports